import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carlos M.',
    role: 'Contador independiente',
    location: 'Bogotá',
    text: 'Antes tenía la información de mis clientes repartida entre Excel, carpetas y mensajes de WhatsApp. Perdía tiempo todos los días buscando datos que deberían estar a la mano. Desde que implementé el sistema, tengo todo centralizado y puedo encontrar lo que necesito en segundos.',
    initials: 'CM'
  }, {
    name: 'Mariana R.',
    role: 'Contadora independiente',
    location: 'Buenos Aires',
    text: 'Lo que más me sirvió fue el control de vencimientos fiscales. Antes vivía con la angustia de que se me pasara alguna fecha importante. Ahora tengo todo planificado con anticipación y los cierres mensuales dejaron de ser un momento de estrés. Las checklists son un antes y un después.',
    initials: 'MR'
  }, {
    name: 'Andrés G.',
    role: 'Contador',
    location: 'Lima',
    text: 'Gestiono más de 30 clientes y siempre sentía que algo se me escapaba. Con las plantillas de seguimiento y el sistema de organización digital, ahora tengo visibilidad completa de cada cliente. Me ahorro fácilmente dos horas por día que antes perdía ordenando documentación.',
    initials: 'AG'
  }, {
    name: 'Laura S.',
    role: 'Contadora independiente',
    location: 'Ciudad de México',
    text: 'Mis cierres fiscales solían ser caóticos: documentos incompletos, clientes que no respondían a tiempo y yo corriendo a último momento. Con este sistema pude armar un proceso ordenado que me permite anticiparme a todo. Ahora trabajo con mucha más tranquilidad y profesionalismo.',
    initials: 'LS'
  }, {
    name: 'Diego P.',
    role: 'Contador',
    location: 'Santiago',
    text: 'Lo probé sin muchas expectativas, pero la verdad es que me cambió la forma de trabajar. El formulario para nuevos clientes y el seguimiento de pagos me ayudaron a profesionalizar mi estudio. Mis clientes notan la diferencia y yo termino el día sin esa sensación de que me faltó hacer algo.',
    initials: 'DP'
  }];
  return <section className="py-20 px-4 bg-[#0B1A2E]" data-id="element-418">
      <div className="max-w-6xl mx-auto" data-id="element-419">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-420">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-421">
            Profesionales contables que ya usan este sistema
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-422">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-slate-800/40 border border-slate-700/50 rounded-xl p-6 ${index === 3 ? 'md:col-span-2 lg:col-span-1' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-2' : ''}`} data-id="element-423">
              <div className="flex items-center gap-4 mb-4" data-id="element-424">
                <div className="w-12 h-12 rounded-full bg-blue-900 text-blue-300 flex items-center justify-center font-bold text-lg border border-blue-700/50" data-id="element-425">
                  {testimonial.initials}
                </div>
                <div data-id="element-426">
                  <h4 className="text-white font-semibold" data-id="element-427">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-slate-400" data-id="element-428">
                    {testimonial.role} • {testimonial.location}
                  </p>
                </div>
              </div>
              <p className="text-slate-300 italic" data-id="element-429">"{testimonial.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}